<template>
  <div style="height: 100vh;">
    <div id="videoContainer" ref="playerContainer" class="player"></div>
  </div>
</template>

<script>
import OvenPlayer from 'ovenplayer';
import Hls from 'hls.js';
import axios from 'axios';

export default {
  data() {
    return {
      player: null,
      playlist: [],
      isVideoPlaying: false
    };
  },
  async mounted() {
    const backUrl = `${window.location.protocol}//${window.location.hostname}:8008`;
    const localurl = window.location.href;
    const url = new URL(localurl);
    const queryString = url.search;
    const value = queryString.substring(1);

    try {
      const response = await axios.post(`${backUrl}/api/play`, { uuid: value });
      if (response.data.tracks) {
        this.playlist = response.data.tracks.map(track => ({
          title: track.filename,
          sources: [{ type: 'hls', file: track.smil_url.trim() }],
        }));

        this.initPlayer();
      }
    } catch (error) {
      console.error('Error fetching video sources:', error);
    }
  },
  methods: {
    initPlayer() {
      //OvenPlayer.debug(true);
      this.playerInstance = OvenPlayer.create('videoContainer', {
        playlist: this.playlist,
        autoStart: true,
        autoFallback: true,
        mute: false,
        doubleTapToSeek: false,
      });

      this.playerInstance.on('playlistChanged', (index) => {
        this.currentVideoIndex = index;
        this.playerName = this.playlist[index].title;

        this.closePlaylist();

        this.isVideoPlaying = false;
        setTimeout(() => {
          this.playerInstance.play();
        }, 300);
      });

      this.playerInstance.on('ready', () => {
        console.log('Player ready.');

        setTimeout(() => {
          this.playerInstance.play();
        }, 300);
      });

      this.playerInstance.on('play', () => {
        this.isVideoPlaying = true;

      });

      this.playerInstance.on('playlistChanged', (index) => {
        this.currentVideoIndex = index;
        this.isVideoPlaying = false;
        setTimeout(() => {
          this.playerInstance.play();
          document.getElementById('videoContainer').classList.remove('playlist-open');
        }, 200);
      });
    },
    closePlaylist() {
      //console.log('클릭!!!!!!!!!!!!!!!!');
      const playlistButton = document.querySelector('.op-close-icon.btn-close');
      if (playlistButton) {
        //console.log('클릭?????????????');
        playlistButton.click();
      } else {
        //console.log('버튼을 찾을 수 없습니다.');
      }
    },
  },
  beforeDestroy() {
    if (this.player) {
      this.player.destroy();
    }
  },
};
</script>

<style scoped>
#videoContainer {
  --op-accent-color: red;
  height: 100%;
}
</style>